"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = exports.createAsync = void 0;
const createAsync = (storeOptions) => {
    const store = new Map();
    const toKey = (key) => storeOptions.namespace != null ? `${storeOptions.namespace}|${key}` : key;
    const _get = (key) => {
        key = toKey(key);
        if (store.has(key)) {
            const entry = store.get(key);
            if (Date.now() > entry.createdAt + entry.expireTime) {
                return null;
            }
            return entry.data;
        }
        else {
            return null;
        }
    };
    const get = (key) => __awaiter(void 0, void 0, void 0, function* () {
        return _get(key);
    });
    const set = (key, value, options) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        key = toKey(key);
        const entry = {
            data: value,
            createdAt: Date.now(),
            expireTime: (_a = options === null || options === void 0 ? void 0 : options.expireTime) !== null && _a !== void 0 ? _a : storeOptions.defaultExpireTime,
        };
        store.set(key, entry);
    });
    const setAdd = (key, value) => __awaiter(void 0, void 0, void 0, function* () {
        key = toKey(key);
        const val = yield get(key);
        if (val != null) {
            val.add(value);
        }
        else {
            set(key, new Set([value]), {
                expireTime: Infinity,
            });
        }
    });
    const setRemove = (key, value) => __awaiter(void 0, void 0, void 0, function* () {
        key = toKey(key);
        const val = yield get(key);
        if (val != null) {
            val.delete(value);
            if (val.size === 0) {
                del(key);
            }
        }
    });
    const del = (key) => __awaiter(void 0, void 0, void 0, function* () {
        key = toKey(key);
        store.delete(key);
    });
    const getAndSetIfNotExists = (key, value, options) => __awaiter(void 0, void 0, void 0, function* () {
        const cached = _get(key);
        if (cached == null) {
            yield set(key, value, options);
            return null;
        }
        else {
            return cached;
        }
    });
    const flush = () => __awaiter(void 0, void 0, void 0, function* () {
        store.clear();
    });
    const backend = {
        get,
        set,
        setAdd,
        setRemove,
        del,
        getAndSetIfNotExists,
        flush,
    };
    return backend;
};
exports.createAsync = createAsync;
const create = (storeOptions) => {
    const store = new Map();
    const toKey = (key) => storeOptions.namespace != null ? `${storeOptions.namespace}|${key}` : key;
    const get = (key) => {
        key = toKey(key);
        if (store.has(key)) {
            const entry = store.get(key);
            if (Date.now() > entry.createdAt + entry.expireTime) {
                return null;
            }
            return entry.data;
        }
        else {
            return null;
        }
    };
    const set = (key, value, options) => {
        var _a;
        key = toKey(key);
        const entry = {
            data: value,
            createdAt: Date.now(),
            expireTime: (_a = options === null || options === void 0 ? void 0 : options.expireTime) !== null && _a !== void 0 ? _a : storeOptions.defaultExpireTime,
        };
        store.set(key, entry);
    };
    const setAdd = (key, value) => {
        key = toKey(key);
        const val = get(key);
        if (val != null) {
            val.add(value);
        }
        else {
            set(key, new Set([value]), {
                expireTime: Infinity,
            });
        }
    };
    const setRemove = (key, value) => {
        key = toKey(key);
        const val = get(key);
        if (val != null) {
            val.delete(value);
            if (val.size === 0) {
                del(key);
            }
        }
    };
    const del = (key) => {
        key = toKey(key);
        store.delete(key);
    };
    const keys = () => {
        return Array.from(store.keys());
    };
    const backend = {
        get,
        set,
        setAdd,
        setRemove,
        del,
        keys,
    };
    return backend;
};
exports.create = create;
//# sourceMappingURL=memory.js.map